<template>
  <a-modal
      :title="`${actType}钉钉登录账号`"
      centered
      :width="640"
      :mask-closable="false"
      :visible="showDingtalkBindForm"
      :confirmLoading="loading"
      @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >

      <a-form-model-item label="手机号" prop="mobile" help="必须是企业内部注册钉钉的手机号！">
        <a-input v-model="model.mobile"/>
      </a-form-model-item>
      
      <a-form-model-item label="登录账号" prop="admin_ids" help="可选择单个或者多个登录账号，清空则解绑钉钉登录关系！">
        <a-select show-search allow-clear mode="multiple" placeholder="请选择" v-model="model.admin_ids"  option-filter-prop="children">
          <a-select-option :value="item.id" v-for="item in admins" :key="item.id" >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
   
    </a-form-model>
    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'DingtalkBind';
</style>

<script>
import DingtalkBind from './DingtalkBind'

export default DingtalkBind
</script>
